var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTradersgym(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4287_39920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.78587 8.40039C4.29046 8.40039 3.88512 8.80573 3.88512 9.30114V11.1026C3.38971 11.1026 2.98438 11.508 2.98438 12.0034C2.98438 12.4988 3.38971 12.9041 3.88512 12.9041V14.7056C3.88512 15.2011 4.29046 15.6064 4.78587 15.6064C5.28129 15.6064 5.68662 15.2011 5.68662 14.7056V9.30114C5.68662 8.80573 5.28129 8.40039 4.78587 8.40039Z",
    fill: "#299310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4961 7.5C16.0007 7.5 15.5954 7.90534 15.5954 8.40075V11.103H8.38939V8.40075C8.38939 7.90534 7.98405 7.5 7.48864 7.5C6.99323 7.5 6.58789 7.90534 6.58789 8.40075V15.6067C6.58789 16.1022 6.99323 16.5075 7.48864 16.5075C7.98405 16.5075 8.38939 16.1022 8.38939 15.6067V12.9045H15.5954V15.6067C15.5954 16.1022 16.0007 16.5075 16.4961 16.5075C16.9916 16.5075 17.3969 16.1022 17.3969 15.6067V8.40075C17.3969 7.90534 16.9916 7.5 16.4961 7.5Z",
    fill: "#299310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0984 11.1026V9.30114C20.0984 8.80573 19.693 8.40039 19.1976 8.40039C18.7022 8.40039 18.2969 8.80573 18.2969 9.30114V14.7056C18.2969 15.2011 18.7022 15.6064 19.1976 15.6064C19.693 15.6064 20.0984 15.2011 20.0984 14.7056V12.9041C20.5938 12.9041 20.9991 12.4988 20.9991 12.0034C20.9991 11.508 20.5938 11.1026 20.0984 11.1026Z",
    fill: "#299310"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4287_39920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradersgym);
export default __webpack_public_path__ + "static/media/traders gym.bb3c832f.svg";
export { ForwardRef as ReactComponent };